var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1150,
    height: 1284,
    viewBox: "0 0 1150 1284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1649_33390)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.714,
    cy: 265.347,
    rx: 301.714,
    ry: 265.347,
    transform: "matrix(-0.313322 0.949647 -0.905202 -0.424981 971.028 423.959)",
    fill: "url(#paint0_linear_1649_33390)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1649_33390",
    x: 0.66983,
    y: -87.7199,
    width: 1271.26,
    height: 1370.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 188.718,
    result: "effect1_foregroundBlur_1649_33390"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1649_33390",
    x1: 301.714,
    y1: 0,
    x2: 301.714,
    y2: 530.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19FFDC",
    stopOpacity: 0.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse9);
export default __webpack_public_path__ + "static/media/Ellipse 9.62ad70f8e71c0e80f995d1fc539cfc43.svg";
export { ForwardRef as ReactComponent };